import { Navigate } from 'react-router-dom';

/**
 * Default Manage Trust home page.
 */
export const ManageSchoolIndex = () => {
    return (<Navigate to="/manage-school/school-details" replace />);
};